// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.back-button {\n  background: none;\n  border: none;\n  color: #484848;\n}\n.back-button:focus {\n  outline: none;\n}\n", ""]);
// Exports
module.exports = exports;
